import * as React from "react";
import { gql, useQuery } from "@apollo/client";

import {
  FindAllCommunitiesQueryQuery,
  Community
} from "../../../../schemaTypes";

export const findAllCommunitiesQuery = gql`
  query FindAllCommunitiesQuery {
    findAllCommunities {
      id
      name
      alias
      logoUrl
      colorCode
      isArchive
      createdAt
      updatedAt
    }
  }
`;

export const newCommunitySubscription = gql`
  subscription NewCommunitySubscription {
    newCommunity {
      id
      name
      alias
      logoUrl
      colorCode
      isArchive
      createdAt
      updatedAt
    }
  }
`;

type NewCommunitySubscriptionResult = {
  newCommunity: Community;
};

export function useFindAllCommunities() {
  const { data, loading, subscribeToMore } = useQuery<FindAllCommunitiesQueryQuery>(findAllCommunitiesQuery);

  React.useEffect(() => {
    if (!subscribeToMore) return;
    const unsubscribe = subscribeToMore({
      document: newCommunitySubscription,
      updateQuery: (prev, { subscriptionData }: { subscriptionData: { data?: NewCommunitySubscriptionResult } }) => {
        if (!subscriptionData.data) return prev;
        return {
          ...prev,
          findAllCommunities: [
            ...prev.findAllCommunities,
            subscriptionData.data.newCommunity
          ]
        };
      }
    });
    return () => unsubscribe();
  }, [subscribeToMore]);

  return {
    communities: data?.findAllCommunities ?? [],
    loading
  };
}